(() => {
  class VantoxProduct {
    constructor(root) {
      if (root.dataset.initialized === 'true') return;

      root.dataset.initialized = 'true';
      this.root = root;

      this.initGallery();
      this.initOffers();
      this.initCountdown();
      this.initBuy();
    }

    initGallery() {
      const thumbnails = [
        ...this.root.querySelectorAll('[data-vx-thumb]')
      ];

      const slides = [
        ...this.root.querySelectorAll('[data-vx-slide]')
      ];

      if (!thumbnails.length || !slides.length) return;

      thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', () => {
          const selectedIndex =
            thumbnail.dataset.vxThumb;

          thumbnails.forEach((item) => {
            const isSelected =
              item === thumbnail;

            item.classList.toggle(
              'is-active',
              isSelected
            );

            item.setAttribute(
              'aria-current',
              isSelected ? 'true' : 'false'
            );
          });

          slides.forEach((slide) => {
            const isActive =
              slide.dataset.vxSlide === selectedIndex;

            slide.classList.toggle(
              'is-active',
              isActive
            );

            const video =
              slide.querySelector('video');

            if (!video) return;

            if (isActive && video.autoplay) {
              video.play().catch(() => {});
            }

            if (!isActive) {
              video.pause();
            }
          });

          thumbnail.scrollIntoView({
            behavior: 'smooth',
            inline: 'center',
            block: 'nearest'
          });
        });
      });
    }

    initOffers() {
      this.offers = [
        ...this.root.querySelectorAll(
          '[data-vx-offer]'
        )
      ];

      if (!this.offers.length) return;

      const requestedId = new URL(window.location.href).searchParams.get('variant') || this.root.dataset.currentVariantId;
      const initialOffer = this.offers.find(offer => offer.dataset.variantId === requestedId) || this.offers.find(offer => offer.classList.contains('is-selected')) || this.offers[0];
      this.selectOffer(initialOffer);

      this.offers.forEach((offer) => {
        offer.addEventListener('click', () => {
          this.selectOffer(offer);
        });
      });
    }

    selectOffer(selectedOffer) {
      const productId = selectedOffer.dataset.productId;
      if (productId && productId !== this.root.dataset.currentProductId && selectedOffer.dataset.productUrl) {
        const destination = new URL(selectedOffer.dataset.productUrl, window.location.origin);
        destination.searchParams.set("variant", selectedOffer.dataset.variantId);
        destination.hash = selectedOffer.id;
        window.location.assign(destination.href);
        return;
      }
      this.offers.forEach((offer) => {
        const isSelected =
          offer === selectedOffer;

        offer.classList.toggle(
          'is-selected',
          isSelected
        );

        offer.setAttribute(
          'aria-checked',
          isSelected ? 'true' : 'false'
        );
      });
      this.syncSelectedOffer(selectedOffer);
    }

    syncSelectedOffer(selectedOffer) {
      const input = this.root.querySelector('[data-vx-variant]');
      const id = selectedOffer.dataset.variantId;
      if (input) {
        input.value = id || '';
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      const available = Boolean(id) && selectedOffer.dataset.available === 'true';
      const buy = this.root.querySelector('[data-vx-buy]');
      if (buy) buy.disabled = !available;
      const cod = this.root.querySelector('[data-vx-cod]');
      if (cod) {
        cod.setAttribute('aria-disabled', String(!available));
        cod.style.pointerEvents = available ? '' : 'none';
        cod.style.opacity = available ? '' : '0.5';
      }
      const error = this.root.querySelector('[data-vx-error]');
      if (error) {
        error.hidden = available;
        error.textContent = id ? 'Este pack no tiene stock disponible por ahora.' : 'Este pack todavía no está vinculado al producto.';
      }
      if (id) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', id);
        window.history.replaceState({}, '', url);
      }
    }

    initCountdown() {
      const countdowns = [
        ...this.root.querySelectorAll(
          '.vx-countdown'
        )
      ];

      countdowns.forEach((countdown) => {
        const output = countdown.querySelector(
          '[data-vx-countdown]'
        );

        if (!output) return;

        const configuredMinutes = Number(
          countdown.dataset.countdownMinutes ||
          480
        );

        const minutes = Math.max(
          1,
          configuredMinutes
        );

        const countdownKey =
          countdown.dataset.countdownKey ||
          this.root.dataset.sectionId ||
          'default';

        const storageKey =
          `vx-countdown-${countdownKey}`;

        let endTime = Number(
          localStorage.getItem(storageKey)
        );

        if (
          !endTime ||
          endTime <= Date.now()
        ) {
          endTime =
            Date.now() +
            minutes * 60 * 1000;

          localStorage.setItem(
            storageKey,
            String(endTime)
          );
        }

        const updateCountdown = () => {
          let remainingTime = Math.max(
            0,
            endTime - Date.now()
          );

          const shouldReset =
            countdown.dataset.countdownReset ===
            'true';

          if (
            remainingTime === 0 &&
            shouldReset
          ) {
            endTime =
              Date.now() +
              minutes * 60 * 1000;

            localStorage.setItem(
              storageKey,
              String(endTime)
            );

            remainingTime =
              endTime - Date.now();
          }

          const totalSeconds = Math.floor(
            remainingTime / 1000
          );

          const hours = String(
            Math.floor(totalSeconds / 3600)
          ).padStart(2, '0');

          const minutesRemaining = String(
            Math.floor(
              (totalSeconds % 3600) / 60
            )
          ).padStart(2, '0');

          const seconds = String(
            totalSeconds % 60
          ).padStart(2, '0');

          output.textContent =
            `${hours}:${minutesRemaining}:${seconds}`;
        };

        updateCountdown();

        window.setInterval(
          updateCountdown,
          1000
        );
      });
    }

    initBuy() {
      const button = this.root.querySelector(
        '[data-vx-buy]'
      );

      if (!button) return;

      const initialLabel = button.querySelector(
        '[data-vx-buy-label]'
      );

      button.dataset.originalLabel =
        initialLabel?.textContent.trim() ||
        'COMPRAR AHORA';

      button.addEventListener(
        'click',
        async () => {
          await this.addSelectedOfferToCart(
            button
          );
        }
      );
    }

    async addSelectedOfferToCart(button) {
      const variantInput = this.root.querySelector(
        '[data-vx-variant]'
      );

      const selectedOffer =
        this.root.querySelector(
          '[data-vx-offer].is-selected'
        );

      const errorMessage =
        this.root.querySelector(
          '[data-vx-error]'
        );

      const label = button.querySelector(
        '[data-vx-buy-label]'
      );

      const loader = button.querySelector(
        '.vx-buy__loader'
      );

      const variantId = Number(
        variantInput?.value
      );

      const quantity = 1;

      if (!variantId) {
        this.showError(
          errorMessage,
          'Selecciona un producto disponible.'
        );

        return;
      }

      button.disabled = true;

      if (label) {
        label.hidden = true;
      }

      if (loader) {
        loader.hidden = false;
      }

      if (errorMessage) {
        errorMessage.hidden = true;
      }

      try {
        const shopRoot =
          window.Shopify?.routes?.root || '/';

        const cartResponse = await fetch(`${shopRoot}cart.js`, { headers: { Accept: 'application/json' } });
        if (!cartResponse.ok) throw new Error('No pudimos revisar el carrito. Intenta nuevamente.');
        const cart = await cartResponse.json();
        const offerIds = new Set(this.offers.map(offer => Number(offer.dataset.variantId)));
        const updates = {};
        let selectedLine = null;
        cart.items.forEach(item => {
          if (!offerIds.has(item.variant_id)) return;
          if (item.variant_id === variantId && !selectedLine) {
            selectedLine = item.key;
            updates[item.key] = quantity;
          } else {
            updates[item.key] = 0;
          }
        });
        if (!selectedLine) updates[variantId] = quantity;

        const response = await fetch(
          `${shopRoot}cart/update.js`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ updates })
          }
        );

        const responseData =
          await response.json();

        if (!response.ok) {
          throw new Error(
            responseData.description ||
            'No pudimos agregar el producto.'
          );
        }

        document.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: responseData
          })
        );

        window.location.href = `${shopRoot}checkout`;
      } catch (error) {
        this.showError(
          errorMessage,
          error.message ||
          'Ocurrió un error. Intenta nuevamente.'
        );
      } finally {
        button.disabled = false;

        if (label) {
          label.hidden = false;
        }

        if (loader) {
          loader.hidden = true;
        }
      }
    }

    async openDrawer(addedItem, shopRoot) {
      const drawer =
        document.querySelector('cart-drawer');

      if (
        drawer &&
        typeof drawer.renderContents === 'function'
      ) {
        try {
          const sectionsResponse = await fetch(
            `${shopRoot}?sections=cart-drawer,cart-icon-bubble`
          );

          const sections =
            await sectionsResponse.json();

          drawer.renderContents({
            ...addedItem,
            sections
          });

          return;
        } catch (error) {
          window.location.href =
            `${shopRoot}cart`;

          return;
        }
      }

      if (
        drawer &&
        typeof drawer.open === 'function'
      ) {
        drawer.open();
        return;
      }

      window.location.href =
        `${shopRoot}cart`;
    }

    showSuccess(button) {
      const label = button.querySelector(
        '[data-vx-buy-label]'
      );

      if (!label) return;

      const originalLabel =
        button.dataset.originalLabel ||
        'COMPRAR AHORA';

      label.textContent = '¡AGREGADO!';

      window.setTimeout(() => {
        label.textContent = originalLabel;
      }, 1800);
    }

    showError(errorNode, message) {
      if (!errorNode) return;

      errorNode.textContent = message;
      errorNode.hidden = false;
    }
  }

  const mountVantoxProducts = (
    scope = document
  ) => {
    const sections = scope.querySelectorAll(
      '[data-vx-product]'
    );

    sections.forEach((section) => {
      new VantoxProduct(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        mountVantoxProducts();
      }
    );
  } else {
    mountVantoxProducts();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      mountVantoxProducts(event.target);
    }
  );
})();